import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconLoadFailed100pxBoldS = function IconLoadFailed100pxBoldS(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 100 100",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "50",
      cy: "50",
      r: "40",
      fill: "#E4E7ED"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M60.599 61.925l-.544-.457a3.75 3.75 0 011.702-6.555l5.804-1.116a3.75 3.75 0 014.17 5.123 23.64 23.64 0 01-2.205 4.104A23.46 23.46 0 0155.42 72.79C42.773 75.785 30.095 67.96 27.1 55.314a3.75 3.75 0 117.299-1.728c2.039 8.615 10.677 13.946 19.292 11.907a15.95 15.95 0 006.907-3.568z",
      fill: "#9EA6B8"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M39.401 37.868l.544.457a3.75 3.75 0 01-1.702 6.555l-5.804 1.116a3.75 3.75 0 01-4.17-5.123 23.645 23.645 0 012.205-4.104 23.46 23.46 0 0114.106-9.767c12.647-2.994 25.325 4.831 28.319 17.477a3.75 3.75 0 11-7.299 1.728C63.561 37.592 54.924 32.261 46.308 34.3a15.952 15.952 0 00-6.907 3.569z",
      fill: "#9EA6B8"
    })]
  }));
};
export default IconLoadFailed100pxBoldS;